import React from "react";

import "./ErrorPage.scss";

export function ErrorPage(props) {
  const msg = !!props.msg ? (
    props.msg
  ) : (
    <h4>
      Something went wrong. Please contact TRI.
      <br />
      <br />
      Refreshing or coming back later may also solve this issue.
    </h4>
  );

  return (
    <div className="page error-page column h-center v-center">
      <h2>Uh oh.</h2>
      {msg}
    </div>
  );
}
